export const obfuscate = (source: string, replacementChar: string = '*'): string => {
  if (!source) {
    return source
  }

  const numberCharToShowBeginning = 2

  let obfuscatedNumber = ''
  let digitCount = 0

  for (const c of source) {
    if (/\d/.test(c)) {
      digitCount++
      obfuscatedNumber += digitCount <= numberCharToShowBeginning ? c : replacementChar
    } else {
      obfuscatedNumber += c
    }
  }

  return obfuscatedNumber
}